import React from "react"
import { useLocation } from "react-router-dom"
import { UserEditor } from "../../components/InternalUserManagement"
import styles from "./styles"

const UserDetails = () => {
  const location = useLocation()

  const classes = styles()

  const { state } = location
  const user = state?.user

  return (
    <div className={classes.root}>
      <UserEditor user={user} />
    </div>
  )
}

export default UserDetails
